/* ===============================================
  MONEY (GLOBAL)
================================================== */
(function initThemeMoneyFormatter() {
  window.theme = window.theme || {};

  if (typeof window.theme.formatMoney === "function") return;

  const stripToNumber = (value) => {
    if (value === null || value === undefined || value === "") return null;
    if (typeof value === "number") return Number.isFinite(value) ? value : null;

    if (typeof value === "string") {
      const normalized = value.replace(/[^\d-]/g, "");
      if (!normalized) return null;
      const n = Number(normalized);
      return Number.isFinite(n) ? n : null;
    }

    return null;
  };

  const formatWithSeparators = (num, decimals, decSep, thouSep) => {
    const fixed = num.toFixed(decimals);
    let [intPart, decPart] = fixed.split(".");

    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);

    return decimals > 0 ? `${intPart}${decSep}${decPart || "0".repeat(decimals)}` : intPart;
  };

  const tokenToRule = (token) => {
    switch (token) {
      case "amount_with_comma_separator":
        return { decimals: 2, decSep: ",", thouSep: "." };
      case "amount_no_decimals_with_comma_separator":
        return { decimals: 0, decSep: ",", thouSep: "." };
      case "amount":
        return { decimals: 2, decSep: ".", thouSep: "," };
      case "amount_no_decimals":
        return { decimals: 0, decSep: ".", thouSep: "," };
      case "amount_with_apostrophe_separator":
        return { decimals: 2, decSep: ".", thouSep: "'" };
      default:
        return null;
    }
  };

  const intlFallback = (value, withCurrency) => {
    const locale = window.theme?.locale || document.documentElement.lang || "it-IT";
    const currency = window.theme?.currency || window.theme?.currency_code; // optional

    try {
      if (withCurrency && currency) {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value);
      }

      return new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (_) {
      // Last resort
      return String(value);
    }
  };

  window.theme.formatMoney = function formatMoney(cents, opts = {}) {
    const { withCurrency = false } = opts;

    const raw = stripToNumber(cents);
    if (raw === null) return "";

    const format = withCurrency
      ? window.theme?.money_with_currency_format
      : window.theme?.money_format;

    const fmt = format || "{{amount}}";
    const tokenMatch = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const token = tokenMatch ? tokenMatch[1] : "amount";

    const value = raw / 100;

    const rule = tokenToRule(token);
    const formatted = rule
      ? formatWithSeparators(value, rule.decimals, rule.decSep, rule.thouSep)
      : intlFallback(value, withCurrency);

    // Preserve any HTML
    const placeholder = tokenMatch ? tokenMatch[0] : "{{amount}}";
    return fmt.replace(placeholder, formatted);
  };
})();

document.addEventListener("DOMContentLoaded", function () {
/* ===============================================
    PRODUCT GALLERY
================================================== */
  function initProductGalleryMobile(scope = document) {
    const container = scope.querySelector('.js-product-gallery-mobile');
    if (!container || container.offsetParent === null) return;

    const mainEl   = container.querySelector('.js-productGalleryMain');
    const thumbsEl = container.querySelector('.js-productGalleryThumbs');
    if (!mainEl || !thumbsEl) return;

    if (mainEl.swiper && thumbsEl.swiper) {
      mainEl.swiper.update();
      thumbsEl.swiper.update();
      return;
    }

    const thumbs = new Swiper(thumbsEl, {
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      loop: false
    });
    
    const main = new Swiper(mainEl, {
      slidesPerView: 1,
      watchOverflow: true,
      loop: false,
      observer: true,
      observeParents: true,
      noSwiping: false,
      noSwipingSelector: 'video, .pg-video',
      thumbs: { swiper: thumbs },
      on: {
        slideChange: function () {
          this.slides.forEach((slide, index) => {
            const video = slide.querySelector('video');
            if (!video) return;
            video.pause();

            if (index === this.activeIndex) {
              video.muted = true;
              try {
                video.currentTime = 0;
              } catch (_) {}

              const playPromise = video.play();

              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            }
          });
        }
      }
    });

    requestAnimationFrame(() => {
      thumbs.update();
      main.update();
      main.slideTo(0, 0, false);
    });
  }

/* ===============================================
    RESIZE (DEBOUNCE)
================================================== */
  let pgResizeRAF = null;

  window.addEventListener('resize', () => {
    if (pgResizeRAF) cancelAnimationFrame(pgResizeRAF);

    pgResizeRAF = requestAnimationFrame(() => {
      initProductGalleryMobile(document);
    });
  });

/* ===============================================
    FULL WIDTH GALLERY
================================================== */
function initFullWidthGallery() {
  const pgOverlay = document.querySelector('.js-pgOverlay');
  if (!pgOverlay) return;

  const overlayEl = pgOverlay.querySelector('.js-pgOverlaySwiper');
  if (!overlayEl) return;

  const gridItems = document.querySelectorAll('.pg-grid-item');
  const mobileMain = document.querySelector('.js-productGalleryMain');

  const pauseVideos = (root, reset = false) => {
    if (!root) return;

    root.querySelectorAll('video').forEach(video => {
      video.pause();

      if (reset) {
        try {
          video.currentTime = 0;
        } catch (_) {}
      }
    });
  };

  const playActiveVideo = (swiper) => {
    if (!swiper || !swiper.slides) return;

    pauseVideos(swiper.el);
    const activeSlide = swiper.slides[swiper.activeIndex];
    const video = activeSlide?.querySelector('video');

    if (!video) return;
    video.muted = true;

    try {
      video.currentTime = 0;
    } catch (_) {}

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
      });
    }
  };

  function closeOverlay() {
    pauseVideos(pgOverlay);
    pgOverlay._pgSwiper?.zoom?.out();

    pgOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function ensureSwiper() {
    if (!pgOverlay._pgSwiper) {
      pgOverlay._pgSwiper = new Swiper(overlayEl, {
        slidesPerView: 1,
        speed: 400,
        loop: false,

        observer: true,
        observeParents: true,

        allowTouchMove: true,
        noSwiping: true,
        noSwipingSelector: 'video, .pg-video',

        zoom: {
          maxRatio: 2.5,
          minRatio: 1
        },

        navigation: {
          nextEl: pgOverlay.querySelector('.js-pgNext'),
          prevEl: pgOverlay.querySelector('.js-pgPrev')
        },

        on: {
          slideChange: function () {
            playActiveVideo(this);
          }
        }
      });
    }

    return pgOverlay._pgSwiper;
  }

  function openOverlayAt(index) {
    if (!Number.isInteger(index) || index < 0) return;

    // Evita riproduzioni contemporanee
    pauseVideos(mobileMain);

    const swiper = ensureSwiper();

    pgOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Sincronizza dimensioni e slide
    swiper.update();
    swiper.slideTo(index, 0, false);
    playActiveVideo(swiper);
  }

  // Desktop: apertura overlay da griglia
  gridItems.forEach(item => {
    item.addEventListener('click', () => {
      const index = Number(item.dataset.index);
      openOverlayAt(index);
    });
  });

  // Mobile
  if (mobileMain) {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoved = false;

    mobileMain.addEventListener('touchstart', (e) => {
      touchMoved = false;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    mobileMain.addEventListener('touchmove', (e) => {
      const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(e.touches[0].clientY - touchStartY);

      if (deltaX > 10 || deltaY > 10) {
        touchMoved = true;
      }
    }, { passive: true });

    mobileMain.addEventListener('click', (e) => {
      if (touchMoved) return;

      const slide = e.target.closest('.swiper-slide');
      if (!slide) return;

      // Non intercettare i controlli del player
      if (e.target.closest('button, a, input, [role="button"]')) {
        return;
      }

      const activeIndex = mobileMain.swiper?.activeIndex;
      if (!Number.isInteger(activeIndex)) return;

      openOverlayAt(activeIndex);
    });
  }


  // Chiusura tramite pulsante
  pgOverlay.querySelector('.js-pgOverlayClose')
    ?.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      closeOverlay();
    });

  // Chiusura solo cliccando sul backdrop
  pgOverlay.addEventListener('click', (e) => {
    if (!pgOverlay.classList.contains('is-open')) return;

    // Non chiudere cliccando sui comandi di navigazione
    if (e.target.closest('.js-pgPrev, .js-pgNext, .js-pgOverlayClose')) {
      return;
    }
    // Non chiudere interagendo con immagini o video
    if (e.target.closest('.js-pgOverlaySwiper img, .js-pgOverlaySwiper video')) {
      return;
    }
    // Chiudi cliccando sullo sfondo della galleria
    closeOverlay();
  });

  // Tastiera
  document.addEventListener('keydown', e => {
    if (!pgOverlay.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeOverlay();
    } else if (e.key === 'ArrowLeft') {
      pgOverlay._pgSwiper?.slidePrev();
    } else if (e.key === 'ArrowRight') {
      pgOverlay._pgSwiper?.slideNext();
    }
  });
}


/* ===============================================
    GALLERY HOVER CURSOR
================================================== */
  function initGalleryHoverCursor() {
    const cursor = document.querySelector('.js-pgCursor');
    const galleryItems = document.querySelectorAll('.pg-grid-item');

    if (
      !cursor ||
      !galleryItems.length ||
      !window.matchMedia('(hover: hover) and (pointer: fine)').matches
    ) return;

    let isActive = false;

    const moveCursor = (e) => {
      if (!isActive) return;
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top  = `${e.clientY}px`;
    };

    galleryItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        isActive = true;
        cursor.classList.add('is-visible');
      });

      item.addEventListener('mouseleave', () => {
        isActive = false;
        cursor.classList.remove('is-visible');
      });
    });

    window.addEventListener('mousemove', moveCursor);
  }

/* ===============================================
    PRODUCT SLIDER
================================================== */
  function initProductSlider(scope = document) {
    if (typeof Swiper === 'undefined') return;

    const section = scope.querySelector('[data-product-slider]');
    if (!section) return;

    const sliderEl = section.querySelector('.product-slider-swiper');
    if (!sliderEl || sliderEl.classList.contains('swiper-initialized')) return;

    const nextBtn = section.querySelector('.js-product-slider-next');
    const prevBtn = section.querySelector('.js-product-slider-prev');
    const progressBar = section.querySelector('.product-slider-progress-fill');

    const swiper = new Swiper(sliderEl, {
      slidesPerView: 1,
      spaceBetween: 16,
      watchOverflow: true,
      navigation: { nextEl: nextBtn, prevEl: prevBtn },
      breakpoints: {
        800:  { slidesPerView: 2, spaceBetween: 16 },
        1024: { slidesPerView: 4,   spaceBetween: 16 },
        1400: { slidesPerView: 4,   spaceBetween: 16 }
      }
    });

    if (progressBar) {
      const updateProgress = () => {
        const total = swiper.slides.length || 1;
        const index = swiper.realIndex + 1;
        progressBar.style.width = `${(index / total) * 100}%`;
      };
      swiper.on('slideChange', updateProgress);
      updateProgress();
    }
  }

/* =========================================================
   QUICK ADD — PDP
========================================================= */
function initQuickAdd(root = document) {
  const quickAdd = document.querySelector('[data-quick-add]');
  const addToCartButton = document.querySelector('.product-form-wrapper .a-btn.cart');

  if (!quickAdd || !addToCartButton) return;
  if (quickAdd.dataset.quickAddInitialized === 'true') return;

  const setVisible = (visible) => {
    quickAdd.classList.toggle('is-visible', visible);
    quickAdd.setAttribute('aria-hidden', visible ? 'false' : 'true');
  };

  const observer = new IntersectionObserver(
    ([entry]) => {
      const addToCartPassed = (
        !entry.isIntersecting &&
        entry.boundingClientRect.bottom <= 0
      );

      setVisible(addToCartPassed);
    },
    {
      root: null,
      threshold: 0
    }
  );
  observer.observe(addToCartButton);
  quickAdd.dataset.quickAddInitialized = 'true';
}
initQuickAdd();

/* =========================================================
   GARANZIA LEGALE — MODAL
========================================================= */
const glDialog = document.querySelector('#gl-dialog');
if (glDialog) {
  document.addEventListener('click', (event) => {
    const openLink = event.target.closest('a[href="#garanzia-legale"]');
    const closeButton = event.target.closest('[data-gl-close]');

    if (openLink) {
      event.preventDefault();
      glDialog.showModal();
    }

    if (closeButton) {
      glDialog.close();
    }
  });

  glDialog.addEventListener('click', (event) => {
    if (event.target === glDialog) {
      glDialog.close();
    }
  });
}

/* ===============================================
    PRODUCT CARD
================================================== */
  function initProductCards(scope = document) {
    const cards = scope.querySelectorAll(".product-card");
    if (!cards.length) return;

    cards.forEach((card) => {
      const swatches = card.querySelectorAll(".js-card-color-switch");
      if (!swatches.length) return;

      const img        = card.querySelector(".js-product-image");
      const links      = card.querySelectorAll(".js-product-link");
      const titleLink  = card.querySelector(".product-card__title a");
      const colorLabel = card.querySelector(".js-product-color-label");
      const priceEl    = card.querySelector(".js-product-price");
      const compareEl  = card.querySelector(".js-product-compare");
      const cta        = card.querySelector("[data-add-to-cart]");

    const setActive = (activeBtn) => {
      swatches.forEach((b) => b.classList.remove("is-active"));
      activeBtn.classList.add("is-active");
    };

    swatches.forEach((btn) => {
      const syncSwatchState = (swatch) => {
        const isDisabled =
          swatch.disabled ||
          swatch.classList.contains("is-disabled") ||
          swatch.getAttribute("aria-disabled") === "true";

        const isActive = swatch.classList.contains("is-active");

        swatch.setAttribute("aria-pressed", isActive ? "true" : "false");
        swatch.setAttribute("aria-disabled", isDisabled ? "true" : "false");

        if (isDisabled) {
          swatch.setAttribute("tabindex", "-1");
        } else {
          swatch.removeAttribute("tabindex");
        }
      };

      syncSwatchState(btn);

      btn.addEventListener("click", () => {
        const currentDisabled =
          btn.disabled ||
          btn.classList.contains("is-disabled") ||
          btn.getAttribute("aria-disabled") === "true";

        if (currentDisabled) return;

        setActive(btn);
        swatches.forEach(syncSwatchState);

        if (img && btn.dataset.image) {
          img.src = btn.dataset.image;

          if (btn.dataset.imageSrcset) {
            img.srcset = btn.dataset.imageSrcset;
          } else {
            img.removeAttribute("srcset");
          }

          if (btn.dataset.productTitle) {
            img.alt = btn.dataset.productTitle;
          }
        }

        if (btn.dataset.productUrl) {
          links.forEach((a) => a.setAttribute("href", btn.dataset.productUrl));
          if (titleLink) titleLink.setAttribute("href", btn.dataset.productUrl);
        }
        if (btn.dataset.productTitle && titleLink) {
          titleLink.textContent = btn.dataset.productTitle;
        }
        if (colorLabel && btn.dataset.colorName) {
          colorLabel.textContent = btn.dataset.colorName;
        }
        if (priceEl && btn.dataset.priceCents) {
          priceEl.innerHTML = window.theme.formatMoney(Number(btn.dataset.priceCents));
        }
        if (compareEl) {
          const compare = Number(btn.dataset.compareCents);
          const price = Number(btn.dataset.priceCents);

          if (Number.isFinite(compare) && compare > price) {
            compareEl.innerHTML = window.theme.formatMoney(compare);
            compareEl.style.display = "";
          } else {
            compareEl.innerHTML = "";
            compareEl.style.display = "none";
          }
        }
        if (cta) {
          if (btn.dataset.productId) cta.dataset.productId = btn.dataset.productId;
          if (btn.dataset.variantId) cta.dataset.variantId = btn.dataset.variantId;
          if (btn.dataset.productTitle) cta.dataset.productTitle = btn.dataset.productTitle;
          if (btn.dataset.priceCents) cta.dataset.productPriceCents = btn.dataset.priceCents;
        }
      });
    });
  });
  }

  initProductCards(document);
  initProductSlider(document);
  initProductGalleryMobile(document);
  initFullWidthGallery();
  initGalleryHoverCursor();
});